module.exports = __webpack_public_path__ + "img/portrait-095.20666065.jpg";